<template>
  <div class="CarouselNavigationWrapper">
    <slot></slot>
    <div class="navigation">
      <CarouselArrowButton reverse class="button" @click="$emit('activatePrevItem')" />
      <CarouselArrowButton class="button" @click="$emit('activateNextItem')" />
    </div>
  </div>
</template>

<script setup>
import CarouselArrowButton from './CarouselArrowButton.vue';
</script>

<style scoped>

.CarouselNavigationWrapper {
  position: relative;
}

.navigation {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 calc(0.5 * var(--gutter-width));
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.15s;
}

.CarouselNavigationWrapper:hover .navigation {
  opacity: 1;
}

.navigation .button {
  pointer-events: all;
}
</style>
